import { useFlag } from "~/config/flags";

import { Logout } from "./Logout";
import { LogoutV2 } from "./LogoutV2";

export const LogoutFlowSelector = () => {
  const { isLogoutV2Enabled } = useFlag();
  return isLogoutV2Enabled ? <LogoutV2 /> : <Logout />;
};
